/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../TextInput';
import { useValidationMessagingArgs, ValidationStates } from '../ValidationMessages';

interface PhoneProps {
    initialValue?: string;
}

const verification: useValidationMessagingArgs = {
    applicableStates: [ValidationStates.MissingRequired],
};

export const Phone: React.FC<PhoneProps> = ({ initialValue }) => {
    const { t } = useTranslation(['common']);

    return (
        <TextInput
            formFieldId="phone"
            isRequired
            inputValidation={verification}
            label={t('common:phoneNumber')}
            name="Phone"
            initialValue={initialValue}
        />
    );
};
